import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function atLeastOneFilledValidator(fieldNames: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormGroup)) return null;

    const isAnyFilled = fieldNames.some(name => {
      const value = control.get(name)?.value;
      // checkbox: true, date/ng-select: non-null/non-empty
      return value !== null && value !== false && value !== '';
    });

    return isAnyFilled ? null : { atLeastOneRequired: true };
  };
}
